export default __webpack_public_path__ + "static/technology_header-22b5014874c072f4a926f2d395473558.svg";